<template>
    <section>
        <div class="row">
            <div class="media-resources-category-container js-appear-animation-row">
                <button v-for="(item, index) in uniqueFilters" class="media-resources-category cta-hover" :class="{'media-resources-category-active': activeCategory == item.CodeName}" :data-category="item.CodeName" @click="handleFilter(item.CodeName)">
                    <div class="hover-text">
                        <div style="display: flex;">
                            {{item.DisplayName}}
                        </div>
                    </div>
                    <div class="hover-text bottom">
                        <div style="display: flex;">
                            {{item.DisplayName}}
                        </div>
                    </div>
                </button>
            </div>
        </div>
        <div class="row">
            <div v-if="listing.length">
                <div class="carousel carousel--recipes cards--related cards--grid cards d-flex">
                    <button class="carousel-btn carousel-btn-left" aria-label="Carousel button Previous"></button>
                    <button class="carousel-btn carousel-btn-right" aria-label="Carousel button Next"></button>
                    <summary-item v-for="(item, index) in listing" v-bind:item="item" v-bind:key="item.DetailID"></summary-item>
                </div>
            </div>

            <div class="cards-no-results col-lg-12" v-if="listing.length < 1">
                <h2>No Results</h2>
                <p>Sorry, there are no results matching your Sort and Filter criteria.</p>
                <a href="javascript:void(0);" v-on:click="resetFilters">Clear Sort and Filters</a>
            </div>
        </div>
    </section>
</template>

<script>
    import SmoothScroll from 'smooth-scroll';
    import { mapState, mapActions, mapMutations } from 'vuex';
    import SummaryItem from '../components/listing/resources-list-summary-item';
    import $ from 'jquery';

    export default {
        props: ['filterid', 'filtertype', 'result', 'resource', 'title', 'filters'],
        data: function () {
            return {
                activeCategory: ''
            }
        },
        computed: {
            ...mapState({
                loading: state => state.listing.loading,
                listing: state => state.listing.listing || [],
                loadedImages: state => state.listing.loadedImages,
            }),

            // New computed property for unique filters
            uniqueFilters() {
                const seen = new Set();
                return this.filters.filter((filter) => {
                    if (seen.has(filter.CodeName)) {
                        return false;
                    } else {
                        seen.add(filter.CodeName);
                        return true;
                    }
                });
            }
        },
        components: {
            'summary-item': SummaryItem,
        },
        mounted: function () {
            let _this = this;

            this.setInitData(this.result);
            this.setResource(this.resource);

            let scroll = new SmoothScroll();
            let options = {
                header: '[data-scroll-header]',
                speed: 1000,
                offset: 96
            };

            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'listing/setLoadedImageState') {
                    if (this.loadedImages === 8) {
                        this.handleLeftToRightAnimation();
                    }
                }
            });

            this.$store.subscribeAction((action, state) => {
                if (action.type === 'listing/setFilter') {
                    let anchor = document.querySelector('#' + _this.filterid);
                    let header = document.getElementsByClassName('header')[0];
                }
            });

            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'listing/updateSpecification') {
                    this.setFilter();
                }
            });
        },
        methods: {
            ...mapActions('listing', { setFilter: 'setFilter' }),
            ...mapMutations('listing', { setInitData: 'setInitData' }),
            ...mapMutations('listing', { setResource: 'setResource' }),
            ...mapMutations('listing', { resetSpecification: 'resetSpecification' }),
            ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
            ...mapMutations('listing', { setLoadedImageInitialState: 'setLoadedImageInitialState' }),

            handleLeftToRightAnimation() {
                const anchorElements = document.querySelectorAll('.card-content-wrapper');

                anchorElements.forEach((item) => {
                    item.classList.add('opacity-0');
                });

                anchorElements.forEach((item, index) => {
                    setTimeout(() => {
                        item.classList.add('fade-in-LtF');
                    }, index * 200);
                });
            },

            resetFilters() {
                this.resetSpecification();
                this.activeCategory = '';
            },

            async handleFilter(filter) {
                const seeMoreBtn = $('#see-more');

                const urls = {
                    DairyNutrition: '/news-articles?Topic=DairyNutrition',
                    Sustainability: '/news-articles?Topic=Sustainability&SearchTerm=cheese&Path=%2Fnews-articles&Sort=Newest&PageIndex=0&PageSize=15&Facets=&IncludeDocumentForPath=false&OnlyShowTopicTags=true&ExcludeSpanish=false#filter-app',
                    LifeOnTheFarm: '/news-articles?Topic=LifeOnTheFarm&SearchTerm=cheese&Path=%2Fnews-articles&Sort=Newest&PageIndex=0&PageSize=15&IncludeDocumentForPath=false&OnlyShowTopicTags=true&ExcludeSpanish=false#filter-app'
                };

                seeMoreBtn.attr('href', urls[filter] || urls.DairyNutrition);

                let selectedFilter = filter;
                if (this.activeCategory === filter) {
                    this.activeCategory = '';
                    selectedFilter = this.uniqueFilters.map(item => item.CodeName);
                } else {
                    this.activeCategory = filter;
                }

                this.updateSpecification({ key: 'Topic', value: selectedFilter });

                try {
                    await this.setFilter();
                } catch (err) {
                    console.error('Filter fetch failed', err);
                }
            }
        }
    }
</script>
